/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { Industry } from '../enums/industry';
import { ExperiencesFocusAreaOrderPreferenceEntity } from './experiences-focus-area-order-preference-entity';
import { ExperiencesTaxonomyEntity } from './experiences-taxonomy-entity';
import { OpportunityEntity } from './opportunity-entity';
export class ExperienceEntity extends Entity {
  accountId: string | null = null;
  candidateId: string | null = null;
  client: string | null = null;
  clientDomain: string | null = null;
  description: string | null = null;
  endDate: string | null = null;
  exceptionApprovedAt: string | null = null;
  exceptionApprovedBy: string | null = null;
  exceptionRequestedAt: string | null = null;
  expectedDescriptionLength: number = 0;
  experiencesFocusAreaOrderPreferences: ExperiencesFocusAreaOrderPreferenceEntity[] = [];
  experienceTaxonomy: ExperiencesTaxonomyEntity[] = [];
  externalOpportunityName: string | null = null;
  generalSkills: string[] | null = null;
  id: string = '';
  industryIsOverridden: boolean = false;
  industryValue: Industry | null = null;
  isConfidential: boolean | null = null;
  lastUpdatedBy: string | null = null;
  locationAddressComponents: Record<string, unknown> | null = null;
  locationName: string | null = null;
  locationPlaceId: string | null = null;
  noFocusAreasApplyMarkedAt: string | null = null;
  opportunity: OpportunityEntity | null = null;
  opportunityId: string | null = null;
  startDate: string | null = null;
  suggestAxiomEngageDismissedAt: string | null = null;
  suggestedFocusAreasRetrievedAt: string | null = null;
  suggestedLegalSkillsRetrievedAt: string | null = null;
  suggestMergeDismissedAt: string | null = null;
  axiom?: boolean | null = null;
  calculatedDisplayName?: string | null = null;
  confidential?: boolean | null = null;
  experienceVisible?: boolean | null = null;
  isAxiom?: boolean | null = null;
  isHighlighted?: boolean | null = null;
  submissionDescription?: string | null = null;
  yearsOfExperience?: number | null = null;
  static override key = 'Experience';
  static override get schema() {
    return {
      opportunity: OpportunityEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Experience' in input
    ) {
      const { Experience: wrapped, ...rest } = input as {
        Experience: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}